import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";

const TagSelector = ({
  title,
  options,
  placeholder,
  isRequired,
  error,
  value,
  onChange,
  ...field
}) => {
  // const [selectedOptions, setSelectedOptions] = useState([]);
  // const [error, setError] = useState("");
  // const handleChange = (selected) => {
  //   setSelectedOptions(selected);
  //   if (isRequired && (!selected || selected.length === 0)) {
  //     setError("At least one option must be selected.");
  //   } else {
  //     setError("");
  //   }
  // };

  //   const clearSelection = () => {
  //     setSelectedOptions([]);
  //     setError(isRequired ? "At least one option must be selected." : "");
  //   };

  return (
    <Form.Group controlId="tag-selector" className="mb-3">
      <Form.Label>{title}</Form.Label>
      <div className="d-flex align-items-center">
        <Select
          isMulti
          options={options}
          {...field}
          value={value} // Explicitly bind value
          onChange={onChange}
          className="basic-multi-select flex-grow-1"
          classNamePrefix="select"
          placeholder={placeholder || ""}
          menuPortalTarget={document.body} 
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 }),
            control: (styles) => ({
              ...styles,
              borderColor: error ? "red" : "#ced4da",
              boxShadow: error ? "0 0 5px red" : "none",
            }),
            multiValue: (styles) => ({
              ...styles,
              backgroundColor: "#B3D4F7",
              borderRadius: "8px",
              padding: "3px 5px",
              margin: "8px 12px",
            }),
            multiValueLabel: (styles) => ({
              ...styles,
              color: "#000",
              fontWeight: "500",
            }),
            multiValueRemove: (styles) => ({
              ...styles,
              color: "#000",
              ":hover": { backgroundColor: "#ffcccc", color: "red" },
            }),
          }}
        />
        {/* {selectedOptions.length > 0 && (
          <Button variant="danger" className="ms-2" onClick={clearSelection}>
            Clear
          </Button>
        )} */}
      </div>
      {error && <div className="text-danger mt-1">{error}</div>}
    </Form.Group>
  );
};

export default TagSelector;
